
import HtmlRenderContainer from '@/components/content-management/html-render-container';
import wrapperOption from '@/components/content-management/quiz/render/option';
import QuizFeedback from '@/components/content-management/quiz/render/feedback';
import QuizMixin from '@/mixins/quiz';

export default {
  props      : ['questions', 'content'],
  components : {
    HtmlRenderContainer,
    wrapperOption,
    QuizFeedback
  },
  mixins: [QuizMixin],
  data() {
    return {
      currentIndex: 0
    };
  },
  computed: {
    isFirst() {
      return this.currentIndex === 0;
    },
    isLast() {
      return this.currentIndex === this.questions.length - 1;
    },
    question() {
      return this.questions[this.currentIndex];
    }
  },
  methods: {
    getLetter(i) {
      return String.fromCharCode(97 + i);
    },
    scrollToQuestionHeader() {
      const element = document.getElementById(`question-wrapper_${this.content.topicId}`);
      const headerOffset = 200;

      window.scroll({
        top      : (element && element.getBoundingClientRect().top + window.pageYOffset) - headerOffset,
        behavior : 'smooth'
      });
    }
  }
};
